import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
   private userUpdate$ = new BehaviorSubject<void>(undefined);

    notifyUserUpdate() {
        this.userUpdate$.next();
    }

    get onUserUpdate() {
        return this.userUpdate$.asObservable();
    }

    getCurrentUser() {
        const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        return user?.name || 'username';
    }
}
